import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DeviceBehfaFilterGroupService {

  constructor(private http: HttpClient) { }

  GetRecord(fullname: String): Observable<Array<any>>{
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfaFilterGroup").pipe(
      map(data=>{
        return data as Array<any>
      })
    )
  }


  addeditDeviceBehfaFilterGroup(model: General_Interface): Observable<General_Interface>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var modelDeviceBehfaFilterGroup = {
      id:model.id,
      title: model.title,
      username: '',
      del:false
    }



    return this.http.post(environment.BaseUrl + "Daro/DeviceBehfaFilterGroup/AddEdit",modelDeviceBehfaFilterGroup,{headers}).pipe(
      map(data=>{
        return data as General_Interface
      })
    )

  }


  Delete(id: number): Observable<boolean>{
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfaFilterGroup/Delete?id="+id
      ).pipe(
      map(data=>{
        return data as boolean
      })
    )
  }


  
  //#region DeviceBehfa

  GetDeviceBehfa(id: number): Observable<Array<DeviceBehfa_Interface>>{
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfaFilterGroup/GetDeviceBehfa?id="+id).pipe(
      map(data=>{
        return data as Array<DeviceBehfa_Interface>
      })
    )
  }

  
  DeleteDeviceBehfa(id: number): Observable<boolean>{
    return this.http.get(environment.BaseUrl + "Daro/DeviceBehfaFilterGroup/DeleteDeviceBehfa?id="+id
      ).pipe(
      map(data=>{
        return data as boolean
      })
    )
  }

  AddDeviceBehfa(DeviceBehfaFilterGroup_id: number,
    DeviceBehfa_id: number):Observable<any>{
    const headers = new HttpHeaders().set('content-type', 'application/json');

    var body = {
      id:0,
      deviceBehfa_id:DeviceBehfa_id,
      filter_id:DeviceBehfaFilterGroup_id,
      Token: ''
    }
    return this.http.post(environment.BaseUrl + "Daro/DeviceBehfaFilterGroup/AddDeviceBehfa",body,{headers}).pipe(
        map(data=>{
          return data as any
        })
    )

  }

  //#endregion


}
